const clientName = client => `${client?.lastName || ''} ${client?.firstName || ''}`.trim();

export const createdAtMillis = value => {
  if (!value) return 0;
  if (typeof value.toMillis === 'function') return value.toMillis();
  const seconds = value.seconds ?? value._seconds;
  if (typeof seconds === 'number') return seconds * 1000;
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const sortClients = (clients, sortMode) => [...clients].sort((a, b) => {
  const byName = clientName(a).localeCompare(clientName(b), undefined, { sensitivity: 'base' });
  if (sortMode === 'alphabetical') return byName;
  return createdAtMillis(b.createdAt) - createdAtMillis(a.createdAt) || byName;
});
